import React, { useCallback, useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { apiClient } from "@/lib/api";

export const GlobalTradeSwitch = () => {
  const [loading, setLoading] = useState(false);
  const [gate, setGate] = useState(null);
  const [error, setError] = useState("");

  const loadGate = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.get("/admin/control/trade-gate");
      setGate(data || null);
      setError("");
    } catch (err) {
      setError(String(err?.response?.data?.detail || err?.message || "trade_gate_fetch_failed"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGate();
  }, [loadGate]);

  const onToggle = useCallback(
    async (checked) => {
      if (loading) return;
      setLoading(true);
      try {
        const { data } = await apiClient.post("/admin/control/trade-gate/toggle", {
          is_trade_enabled: Boolean(checked),
          reason_code: checked ? "TRADING_ENABLED" : "TRADING_DISABLED_BY_UI",
          reason_detail: checked ? "ui_toggle_enabled" : "ui_toggle_disabled",
        });
        setGate(data || null);
        setError("");
      } catch (err) {
        setError(String(err?.response?.data?.detail || err?.message || "trade_gate_toggle_failed"));
      } finally {
        setLoading(false);
      }
    },
    [loading],
  );

  const isTradeEnabled = Boolean(gate?.is_trade_enabled);

  return (
    <div className="rounded-md border border-slate-700 bg-slate-950/80 p-3" data-testid="global-trade-switch-card">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-slate-100" data-testid="global-trade-switch-title">Trade Switch</p>
          <p className="text-xs text-slate-400" data-testid="global-trade-switch-status-label">
            {isTradeEnabled ? "Trade Enabled" : "Trade Disabled"}
          </p>
        </div>
        <Switch
          checked={isTradeEnabled}
          onCheckedChange={onToggle}
          disabled={loading}
          data-testid="global-trade-switch-toggle"
          aria-label="Global Trade Switch"
        />
      </div>
      <div className="mt-2 space-y-1 text-xs text-slate-400">
        <p data-testid="global-trade-switch-reason">Reason: {gate?.reason_code || "-"}</p>
        <p data-testid="global-trade-switch-updated-at">Updated At: {gate?.updated_at || "-"}</p>
        <p data-testid="global-trade-switch-updated-by">Updated By: {gate?.updated_by || "-"}</p>
        {error ? <p className="text-rose-300" data-testid="global-trade-switch-error">{error}</p> : null}
      </div>
    </div>
  );
};
